import * as yup from "yup";

export const serviceFormValidationSchema = yup.object().shape({
  art: yup.string().nullable().required("Campo obligatorio"),
  subnomenclador: yup.string().required("Campo obligatorio"),
  prestacion: yup.string().required("Campo obligatorio").max(8, "Máximo 8 caracteres"),
  nombre: yup.string().required("Campo obligatorio").max(60, "Máximo 60 caracteres"),
  descripcion: yup.string().required("Campo obligatorio"),
});